<template>
	<div class="bigBoss">
		<div style="margin-bottom: 20px;">
			<el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
		</div>

		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" class="demo-form-inline">
				<el-form-item>
					<el-input size clearable v-model="terminal_sn" placeholder="请输入SN"></el-input>
				</el-form-item>
				<el-form-item>
					<el-select size clearable v-model="is_exchange" placeholder="兑换状态">
						<el-option label="已兑换" :value="1"></el-option>
						<el-option label="未兑换" :value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-date-picker size clearable v-model="rangeDate" type="datetimerange" range-separator="至"
						start-placeholder="兑换开始日期" end-placeholder="兑换结束日期" value-format="yyyy-MM-dd"
						@change="pickerChange"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(terminal_sn)">查询</el-button>
					<el-button size="medium" type="primary" icon="el-icon-check" style="font-size: 12px;"
						@click="redeem()">去兑换</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<div style="margin-bottom:20px;font-size: 16px;font-weight: bold;">
				<span>总激活数：{{detail.active_num}} 台</span>
				<span style="margin:0px 50px;">未兑换数：{{detail.unexchange_num}} 台</span>
				<span>已兑换数：{{detail.exchange_num}} 台</span>
			</div>
			<el-table :data="stockInfoList" size="mini" border style="width: 100%" v-loading="loading"
				@selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55" :selectable="selectableFun">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="sn" label="终端号"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="is_bind" label="绑定状态"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="bind_time" label="绑定时间"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="is_active" label="激活状态"
					min-width="120"></el-table-column>
				<el-table-column header-align="center" align="center" prop="active_time" label="激活时间"
					min-width="120"></el-table-column>

				<el-table-column header-align="center" align="center" prop="is_exchange" label="兑换状态" min-width="120">
					<template slot-scope="scope">
						<span v-if="scope.row.is_exchange == '未兑换'"
							style="color: #67C23A;">{{scope.row.is_exchange}}</span>
						<span v-if="scope.row.is_exchange == '已兑换'"
							style="color: #F56C6C;">{{scope.row.is_exchange}}</span>
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="exchange_time" label="兑换时间"
					min-width="120"></el-table-column>
				
			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize"></paginations>
		</el-card>
	</div>
</template>

<script>
	import paginations from '../../../components/pagination/paginations';
	export default {
		name: "UtsInfo",
		data() {
			return {
				stockInfoList: [],
				title: {
					belongTo: '',
					count: ''
				},
				terminal_sn: '',
				is_exchange: '',
				exchange_time_start: '',
				exchange_time_end: '',
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 0 //总数
				},
				rangeDate: '',
				loading: false,
				multipleSelection: [],
				detail: {},
			};
		},
		components: {
			paginations,
		},
		mounted() {
			this.detail = this.$route.query.data;
			this.getData({
				page: this.page.currentPage,
				limit: this.page.pageSize,
				user_id: this.detail.id,
			});
		},
		methods: {
			//勾选
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			//去兑换
			redeem() {
				let data = [];
				if (this.multipleSelection.length == 0) {
					this.$message.error('请勾选终端');
					return false;
				}
				this.multipleSelection.map(res => {
					data.push({
						terminal_id: res.id,
						sn: res.sn
					})
				})
				this.$confirm('确认兑换终端?', ' ', {
				    confirmButtonText: '确 定',
				    cancelButtonText: '取 消',
				    type: 'warning',
				}).then(() => {
					this.$api.post('terminal/exchange_terminal', {
						data: data,
						user_id: this.detail.id
					}, res => {
						if (res.code == 0) {
							this.$message.success(res.msg);
							this.getData({
								page: this.page.currentPage,
								limit: this.page.pageSize,
								user_id: this.detail.id,
							});
						} else {
							this.$message.error(res.msg);
						}
					})
				}).catch(() => { });
			},
			//判断是否兑换
			selectableFun(row, index) {
				if (row.is_exchange == '未兑换') {
					return true
				}
			},
			onSearch(terminal_sn) {
				this.getData({
					page: 1,
					limit: 10,
					terminal_sn,
					user_id: this.detail.id,
					is_exchange: this.is_exchange,
					exchange_time_start: this.exchange_time_start,
					exchange_time_end: this.exchange_time_end
				});
			},

			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.page.currentPage = page;
				this.loading = true;
				this.getData({
					page: this.page.currentPage,
					limit: this.page.pageSize,
					user_id: this.detail.id,
				});
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.loading = true;
				this.page.pageSize = limit;
				this.page.currentPage = this.page.currentPage;
				this.getData({
					page: this.page.currentPage,
					limit: limit,
					user_id: this.detail.id,
				})
			},
			getData(params) {
				this.$api.post('terminal/get_user_exchange_terminal_list', params, res => {
					let data = res.data;
					this.page.total = data.count; //总数
					this.stockInfoList = data.list; //列表
					this.title.count = data.count; //库存数量
					//渲染结束后取消加载
					this.loading = false;
				})
			},
			pickerChange(DateArr) { //时间选择器
				this.exchange_time_start = this._.isEmpty(DateArr) ? '' : DateArr[0];
				this.exchange_time_end = this._.isEmpty(DateArr) ? '' : DateArr[1];
			}
		},
	};
</script>

<style scoped lang="scss">
	.bigBoss {
		font-size: 12px;

		.el-input__inner,
		.tips {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}

		::v-deep .el-form-item__label {
			padding: 0;
			font-size: 12px;
		}

		.titleTip {
			padding: 10px 10px;
			background-color: #ecf8ff;
			border-radius: 4px;
			font-size: 13px;
			font-weight: 700;
			border-left: 5px solid #50bfff;
			margin: 10px 0;
		}

		.title p {
			font-size: 12px;

			:first-child {
				font-weight: 700;
			}
		}
	}
</style>